import React from "react";
import { Sparkles } from "lucide-react";

/** Reusable emerald-pill section eyebrow used across landing sections. */
export const SectionLabel = ({ children }) => (
  <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-50 border border-emerald-200 text-[11px] text-emerald-700 font-bold tracking-[0.12em] uppercase">
    <Sparkles className="w-3 h-3" /> {children}
  </div>
);

export default SectionLabel;
